export const API_UPLOAD_IMAGE = "/media/api/files/upload";
